import React, { useEffect, useRef, useState } from "react";
import { Flex, Box, Grid, GridItem, FormControl, FormLabel, Input, Select, Button, Text, Image, FormErrorMessage, InputGroup, InputLeftElement, } from "@chakra-ui/react";
import MyDiv from "./basicDetails.style";
import { CustomToast } from "../../../../../components";
import { useFetch } from "../../../../../hooks/useFetch";
import { MultiSelectMenu } from "../../../../../components/MultiSelectMenu/MultiSelectMenu";
import { BasicDetailsForm } from "../../modal";
import { IGender } from "../../../../Admin/Master/Gender/model";
import { IBranchDropdown } from "../../../../Admin/Master/Branch/model";
import { IDepartment } from "../../../../Admin/Master/Department/model";
import { IShift } from "../../../../Admin/Master/Shift/model";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Checkbox } from "@chakra-ui/react";
import UploadLogo from "../../../../../assets/images/UploadLogo.svg";
import { ArrowForwardIcon } from "@chakra-ui/icons";


interface BasicDetailsProps {
  nextStep: () => void;
  prevStep: () => void;
  basicDetails: BasicDetailsForm;
  setBasicDetails: React.Dispatch<React.SetStateAction<BasicDetailsForm>>;
  employeeId?: number | null;
  setEmployeeId?: React.Dispatch<React.SetStateAction<number | null>>;
}

const schema = yup.object({
  fullName: yup.string().required("Full name is required.").matches(/^[A-Za-z\s]+$/, "Full name can only contain letters and spaces"),
  personalEmail: yup .string() .email("Enter a valid Personal Email") .required("Personal email is required.") .test(
    "different-email", "Personal Email and Official Email cannot be the same",
    function (value) {
      return ( !value || value.toLowerCase() !==   (this.parent.officialEmail || "").toLowerCase() );
    }
  ),
  phoneNumber: yup.string().required("Phone number is required.").matches(/^(\+91\s?)?[6-9]\d{4}\s?\d{5}$/, "Enter a valid Indian phone number") .test(
    "different-emergency", "Phone Number and Emergency Contact Number cannot be the same",
    function (value) {
      const phone = (value || "").replace(/\D/g, ""); const emergency = (this.parent.emergency_Contact_Number || "").replace(/\D/g, "");
      return !phone || phone !== emergency;
    }
  ),
  whatsAppNumber: yup.string().required("whatsApp number is required.").matches(/^(\+91\s?)?[6-9]\d{4}\s?\d{5}$/, "Enter a valid Indian whatsApp number"),
  gender: yup.number().required("Gender is required.").min(1, "Gender is required").typeError("Gender is required."),
  dob: yup.string().required("Date of birth is required."),
  joiningDate: yup.string().required("Date of joining is required."),
  current_Zipcode: yup.string().required("Zipcode is required"),
  current_Country: yup.string().required("Country is required"),
  current_State: yup.string().required("State is required"),
  current_City: yup.string().required("City is required"),
  current_Address: yup.string().required("Current address is required"),

  permanent_Zipcode: yup.string().required("Zipcode is required"),
  permanent_Country: yup.string().required("Country is required"),
  permanent_State: yup.string().required("State is required"),
  permanent_City: yup.string().required("City is required"),
  permanent_Address: yup.string().required("Permanent address is required"),
  officialEmail: yup .string() .email("Enter a valid Official Email") .required("Official email is required.") .test(
    "different-email", "Official Email and Personal Email cannot be the same",
    function (value) {
      return ( !value || value.toLowerCase() !==   (this.parent.personalEmail || "").toLowerCase() );
    }
  ),
  designation: yup.number().required("Designation is required.").min(1, "Designation is required").typeError("Designation is required."),
  usCompanyId: yup.number().typeError("Company is required.").required("Company is required.").min(1, "Company is required"),
  branch: yup.number().required("Branch is required.").min(1, "Branch is required").typeError("Branch is required."),
  department: yup.number().required("Department is required.").min(1, "Department is required").typeError("Department is required."),
  shift: yup.number().required("Shift is required.").min(1, "Shift is required").typeError("Shift is required."),
  emergency_Contact_Name: yup.string().required("Emergency contact name is required").matches(/^[A-Za-z\s]+$/, "Full name can only contain letters and spaces"),
  emergency_Contact_Number: yup.string().required("Emergency Phone number is required.").matches( /^(\+91\s?)?[6-9]\d{4}\s?\d{5}$/, "Enter a valid phone number" )
  .test( "different-phone", "Emergency Contact Number cannot be the same as Phone Number",
    function (value) {
      const emergency = (value || "").replace(/\D/g, ""); const phone = (this.parent.phoneNumber || "").replace(/\D/g, "");
      return !emergency || emergency !== phone;
    }
  ),  blood_Group_Id: yup.number().required("Blood group is required.").min(1, "Blood group is required.").typeError("Blood group is required."),
});

const BasicDetails: React.FC<BasicDetailsProps> = ({ nextStep, basicDetails, setBasicDetails, employeeId, setEmployeeId, }) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [loading, setLoading] = useState(false);
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);
  const [profile, setProfile] = useState<File | null>(null);
  const [genderOptions, setGenderOptions] = useState<IGender[]>([]);
  const [roleOptions, setRoleOptions] = useState<any[]>([]);
  const [companyOptions, setCompanyOptions] = useState<any[]>([]);
  const [branchOptions, setBranchOptions] = useState<IBranchDropdown[]>([]);
  const [departmentOptions, setDepartmentOptions] = useState<IDepartment[]>([]);
  const [shiftOptions, setShiftOptions] = useState<IShift[]>([]);
  const [designationOption, setDesignationOption] = useState<any[]>([]);
  const [selectedRoles, setSelectedRoles] = useState<number[]>(
    basicDetails.role || []
  );
  const [sameAsCurrent, setSameAsCurrent] = useState(false);
  const [sameAsPhone, setSameAsPhone] = useState(false);
  const [bloodDropdown, setBloodDropdown] = useState<any>([])

  const [isResetDone, setIsResetDone] = useState(false);
  const { register, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<BasicDetailsForm>({
    resolver: yupResolver(schema),
    defaultValues: basicDetails,
    mode: "onBlur",
  });


  useEffect(() => {
    if (basicDetails.employeeId) {
      if (genderOptions.length > 0 && companyOptions.length > 0 && departmentOptions.length > 0 && shiftOptions.length > 0)
        if (basicDetails.usCompanyId) {
          loadBranchOptions(basicDetails.usCompanyId);
        }
      if (basicDetails.department) {
        loadDesignationOptions(basicDetails.department);
      }
    }
  }, [basicDetails, companyOptions.length, departmentOptions.length, genderOptions.length, shiftOptions.length]);

  useEffect(() => {
    if (basicDetails.employeeId) {
      if (!isResetDone && branchOptions.length > 0 && designationOption.length > 0) {
        reset(basicDetails);
        setIsResetDone(true);
      }
    }
  }, [basicDetails, reset, isResetDone, branchOptions.length, designationOption.length]);

  // Calculate date 18 years ago
  const eighteenYearsAgo = new Date();
  eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18);
  const defaultDOB = eighteenYearsAgo.toISOString().split("T")[0]; // YYYY-MM-DD

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setProfile(file);
      // setPreview(URL.createObjectURL(file));
    }
  };

  /** Submit handler */
  const onSubmit = async (formValues: BasicDetailsForm) => {
    try {
      setLoading(true);
      if (selectedRoles.length === 0) {
        addToast({ message: "At least one role is required", status: "error" });
        setLoading(false);
        return;
      }

      // Update parent state
      setBasicDetails({ ...formValues, role: selectedRoles });

      // Add role array to formValues
      const payload = { ...formValues, role: selectedRoles };
      const formData = new FormData();
      if (profile) formData.append("profileImage", profile);

      // Append entire formValues as JSON string under "Data"
      formData.append("Data", JSON.stringify(payload));

      const response = await fetchApi("Hrlense_Employee/BasicDetails", "POST", formData, null, "", true);
      if (response) {
        addToast({ message: response.message, status: 'success' })
        if (response?.employeeId) {
          setBasicDetails((prev) => ({
            ...prev,
            employeeId: response.employeeId,
            employee_Code: response.employee_Code,
          }));
          if (setEmployeeId) {
            setEmployeeId(response.employeeId)
            nextStep();
          };
        }
      }
    } catch (error: any) {
      addToast({ message: error.message || "Something went wrong", status: "error", });
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      if (name === "usCompanyId") {
        console.log(value.usCompanyId);
        if (value.usCompanyId) {
          loadBranchOptions(value.usCompanyId)
        } else {
          loadBranchOptions(0)
        }
      }
      if (name === "department") {
        if (value.department) {
          loadDesignationOptions(Number(value.department))
        } else {
          loadDesignationOptions(0)
        }
      }

    });
    return () => subscription.unsubscribe();
  }, [watch]);



  useEffect(() => {
    if (sameAsCurrent) {
      setValue("permanent_Zipcode", watch("current_Zipcode"));
      setValue("permanent_Country", watch("current_Country"));
      setValue("whatsAppNumber", watch("phoneNumber"));
      setValue("permanent_State", watch("current_State"));
      setValue("permanent_City", watch("current_City"));
      setValue("permanent_Address", watch("current_Address"));
    } else {
      setValue("permanent_Zipcode", "");
      setValue("permanent_Country", "");
      setValue("permanent_State", "");
      setValue("permanent_City", "");
      setValue("permanent_Address", "");
    }
  }, [sameAsCurrent, watch("current_Zipcode"), watch("current_Country"), watch("current_State"), watch("current_City"), watch("current_Address"), watch("phoneNumber")]);

  /** Dropdown loaders */
  const loadGenderOptions = async () => {
    const res = await fetchApi("DropDown/gender", "GET", null, "", "");
    if (res) setGenderOptions(res);
  };
  const loadRoleOptions = async () => {
    const res = await fetchApi("DropDown/role", "GET", null, "", "");
    if (res) setRoleOptions(res);
  };
  const UsCompany = async () => {
    const response = await fetchApi("DropDown/UsCompany", "GET", null, "", "");
    if (response) setCompanyOptions(response);
  };
  const loadBranchOptions = async (companyId: number) => {
    const res = await fetchApi("DropDown/branches", "GET", null, `companyId=${companyId}`, "");
    if (res) setBranchOptions(res);
    else setBranchOptions([]);
  };
  const loadDepartmentOptions = async () => {
    const res = await fetchApi("DropDown/department", "GET", null, "", "");
    if (res) setDepartmentOptions(res);
  };
  const loadShiftOptions = async () => {
    const res = await fetchApi("DropDown/shift", "GET", null, "", "");
    if (res) setShiftOptions(res);
  };
  const loadDesignationOptions = async (department: number) => {
    const res = await fetchApi("DropDown/designation", "GET", null, `department=${department}`, "");
    if (res) setDesignationOption(res);
  };
  const BloodGroupDropDown = async () => {
    const response = await fetchApi("DropDown/bloodGroup", "GET", null, "");
    if (response) {
      setBloodDropdown(response);
    }
  };
  useEffect(() => {
    loadGenderOptions();
    loadRoleOptions();
    UsCompany();
    loadDepartmentOptions();
    loadShiftOptions();
    BloodGroupDropDown();
  }, []);

  const handleCurrentPincodeBlur = async () => {
    const pin = watch("current_Zipcode");
    const result = await fetchAddressByPincode(pin);

    if (result) {
      setValue("current_Country", result.country);
      setValue("current_State", result.state);
      setValue("current_City", result.city);

      if (sameAsCurrent) {
        setValue("permanent_Zipcode", pin);
        setValue("permanent_Country", result.country);
        setValue("permanent_State", result.state);
        setValue("permanent_City", result.city);
      }
    }
  };

  const handlePermanentPincodeBlur = async () => {
    if (sameAsCurrent) return;
    const pin = watch("permanent_Zipcode");
    const result = await fetchAddressByPincode(pin);

    if (result) {
      setValue("permanent_Country", result.country);
      setValue("permanent_State", result.state);
      setValue("permanent_City", result.city);
    }
  };


  const fetchAddressByPincode = async (pincode: string) => {
    if (!pincode || pincode.length < 6) return null;

    try {
      const res = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
      const data = await res.json();
      if (data[0].Status !== "Success") return null;
      const info = data[0].PostOffice[0];
      return { country: info.Country || "India", state: info.State, city: info.District };
    } catch {
      return null;
    }
  };


  return (
    <MyDiv>
      <Box m={6} as="form" onSubmit={handleSubmit(onSubmit)}>
        <Grid templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }} gap={6}>

          {/* Column 1 - Personal Details */}
          <FormControl mb={4} isInvalid={!!errors.fullName} isRequired>
            <FormLabel>Full Name</FormLabel>
            <Input
              type="text"
              placeholder="Enter full name"
              {...register("fullName")}
              onInput={(e: any) => {
                const val = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                e.target.value = val;
              }}
            />
            <FormErrorMessage>{errors.fullName?.message}</FormErrorMessage>
          </FormControl>

          <FormControl mb={4}>
            <FormLabel>
              Employee ID{" "}
              <Text as="span" fontSize="sm" color="gray.500">
                (Auto Generated)
              </Text>
            </FormLabel>
            <Input isDisabled bg="gray.200" value={basicDetails.employee_Code || ""} />
          </FormControl>

          <FormControl mb={4} isInvalid={!!errors.gender} isRequired>
            <FormLabel>Gender</FormLabel>
            <Select placeholder="Select gender" {...register("gender", { valueAsNumber: true })}>
              {genderOptions.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.gender}
                </option>
              ))}
            </Select>
            <FormErrorMessage>{errors.gender?.message}</FormErrorMessage>
          </FormControl>

          <FormControl mb={4} isInvalid={!!errors.dob} isRequired>
            <FormLabel>Date of Birth</FormLabel>
            <Input type="date" defaultValue={basicDetails.dob || defaultDOB} max={defaultDOB}  {...register("dob")} />
            <FormErrorMessage>{errors.dob?.message}</FormErrorMessage>
          </FormControl>

          <FormControl mb={4} isInvalid={!!errors.personalEmail} isRequired>
            <FormLabel>Personal Email</FormLabel>
            <Input
              type="email"
              placeholder="Enter personal email"
              {...register("personalEmail")}
            />
            <FormErrorMessage>{errors.personalEmail?.message}</FormErrorMessage>
          </FormControl>

          <FormControl mb={4} isInvalid={!!errors.phoneNumber} isRequired>
            <FormLabel>Phone Number</FormLabel>
            <Input type="tel" placeholder="Enter phone number"  {...register("phoneNumber")} maxLength={16} onInput={(e: any) => {
              let val = e.target.value.replace(/\D/g, "");
              if (val.startsWith("91")) {
                val = val.slice(2);
              }
              if (val.length > 5) {
                val = `${val.slice(0, 5)} ${val.slice(5, 10)}`;
              }
              e.target.value = `+91 ${val}`;
            }}
            />
            <FormErrorMessage>{errors.phoneNumber?.message}</FormErrorMessage>
          </FormControl>


          <FormControl mb={4} isInvalid={!!errors.whatsAppNumber} isRequired>
            <Flex align="center" justify="space-between">
              <FormLabel>Whatsapp Number</FormLabel>
              <Checkbox
                isChecked={sameAsPhone}
                onChange={(e) => {
                  const checked = e.target.checked;
                   setSameAsPhone(checked);
                  if (checked) {
                    setValue("whatsAppNumber", watch("phoneNumber"));
                  } else {
                    setValue("whatsAppNumber", "");

                  }
                }}
              >
                Same as Current
              </Checkbox>
            </Flex>

            <Input type="tel" placeholder="Enter whatsApp Number"  {...register("whatsAppNumber")} maxLength={16} onInput={(e: any) => {
              let val = e.target.value.replace(/\D/g, "");
              if (val.startsWith("91")) {
                val = val.slice(2);
              }
              if (val.length > 5) {
                val = `${val.slice(0, 5)} ${val.slice(5, 10)}`;
              }
              e.target.value = `+91 ${val}`;
            }}
              isDisabled={sameAsPhone}
            />
            <FormErrorMessage>{errors.whatsAppNumber?.message}</FormErrorMessage>
          </FormControl>


          {/* Column 2 - Job / Official Details */}
          <FormControl mb={4} isInvalid={!!errors.officialEmail} isRequired>
            <FormLabel>Official Email</FormLabel>
            <Input type="email" placeholder="Enter official email" {...register("officialEmail")} />
            <FormErrorMessage>{errors.officialEmail?.message}</FormErrorMessage>
          </FormControl>

          <FormControl mb={4} isInvalid={!!errors.usPhone} >
            <FormLabel>US Phone</FormLabel>
            <Input
              type="tel"
              placeholder="Enter US phone number"
              maxLength={14}
              {...register("usPhone")}
              onInput={(e: any) => {
                let val = e.currentTarget.value.replace(/\D/g, "");
                if (val.startsWith("1")) {
                  val = val.slice(1);
                }

                if (val.length > 3 && val.length <= 6) {
                  val = `(${val.slice(0, 3)}) ${val.slice(3)}`;
                } else if (val.length > 6) {
                  val = `(${val.slice(0, 3)}) ${val.slice(3, 6)}-${val.slice(6, 10)}`;
                } else if (val.length > 0) {
                  val = `(${val}`;
                }

                e.currentTarget.value = `+1 ${val}`;
              }}
            />
            <FormErrorMessage>{errors.usPhone?.message}</FormErrorMessage>
          </FormControl>

          <FormControl mb={4} isInvalid={!!errors.usCompanyId} isRequired>
            <FormLabel>Company</FormLabel>
            <Select
              placeholder="Select Company"
              {...register("usCompanyId", { valueAsNumber: true })}
            >
              {companyOptions.map((com) => (
                <option key={com.id} value={com.id}>
                  {com.company_Name}
                </option>
              ))}
            </Select>
            <FormErrorMessage>{errors.usCompanyId?.message}</FormErrorMessage>
          </FormControl>

          <FormControl mb={4} isInvalid={!!errors.branch} isRequired>
            <FormLabel>Branch</FormLabel>
            <Select
              placeholder="Select branch"
              {...register("branch")}
              isDisabled={branchOptions.length < 1}
            >
              {branchOptions.map((option) => (
                <option key={option.branch_Id} value={option.branch_Id}>
                  {option.branchName}
                </option>
              ))}
            </Select>
            <FormErrorMessage>{errors.branch?.message}</FormErrorMessage>
          </FormControl>

          <FormControl mb={4} isInvalid={!!errors.department} isRequired>
            <FormLabel>Department</FormLabel>
            <Select placeholder="Select department" {...register("department")}>
              {departmentOptions.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.departmentName}
                </option>
              ))}
            </Select>
            <FormErrorMessage>{errors.department?.message}</FormErrorMessage>
          </FormControl>

          <FormControl mb={4} isInvalid={!!errors.designation} isRequired>
            <FormLabel>Designation</FormLabel>
            <Select
              placeholder="Select designation"
              {...register("designation")}
              isDisabled={designationOption.length < 1}
            >
              {designationOption.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.designation}
                </option>
              ))}
            </Select>
            <FormErrorMessage>{errors.designation?.message}</FormErrorMessage>
          </FormControl>

          <FormControl mb={4} isInvalid={!!errors.shift} isRequired>
            <FormLabel>Shift</FormLabel>
            <Select placeholder="Select shift" {...register("shift")}>
              {shiftOptions.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.shift}
                </option>
              ))}
            </Select>
            <FormErrorMessage>{errors.shift?.message}</FormErrorMessage>
          </FormControl>

          <FormControl mb={4} isInvalid={!!errors.joiningDate} isRequired>
            <FormLabel>Date of Joining</FormLabel>
            <Input type="date" {...register("joiningDate")} />
            <FormErrorMessage>{errors.joiningDate?.message}</FormErrorMessage>
          </FormControl>


          {/* Column 3 - Address & Emergency Details */}
          <FormControl mb={4} isInvalid={!!errors.current_Zipcode} isRequired>
            <FormLabel>Current Zipcode</FormLabel>
            <Input maxLength={6} {...register("current_Zipcode")} onBlur={handleCurrentPincodeBlur} />
            <FormErrorMessage>
              {errors.current_Zipcode?.message}
            </FormErrorMessage>
          </FormControl>

          <FormControl mb={4} isInvalid={!!errors.current_Country} isRequired>
            <FormLabel>Current Country</FormLabel>
            <Input {...register("current_Country")} />
            <FormErrorMessage>
              {errors.current_Country?.message}
            </FormErrorMessage>
          </FormControl>

          <FormControl mb={4} isInvalid={!!errors.current_State} isRequired>
            <FormLabel>Current State</FormLabel>
            <Input {...register("current_State")} />
            <FormErrorMessage>
              {errors.current_State?.message}
            </FormErrorMessage>
          </FormControl>

          <FormControl mb={4} isInvalid={!!errors.current_City} isRequired>
            <FormLabel>Current City</FormLabel>
            <Input {...register("current_City")} />
            <FormErrorMessage>
              {errors.current_City?.message}
            </FormErrorMessage>
          </FormControl>

          <FormControl mb={4} isInvalid={!!errors.current_Address} isRequired>
            <FormLabel>Current Address</FormLabel>
            <Input {...register("current_Address")} />
            <FormErrorMessage>
              {errors.current_Address?.message}
            </FormErrorMessage>
          </FormControl>
          <FormControl mb={4} isInvalid={!!errors.permanent_Zipcode}>
            <Flex align="center" justify="space-between">
              <FormLabel>Permanent Zipcode</FormLabel>
              {/* <Checkbox
                isChecked={sameAsCurrent}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setSameAsCurrent(checked);
                }}
              >
                Same as Current
              </Checkbox> */}

              <Checkbox
                isChecked={sameAsCurrent}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setSameAsCurrent(checked);
                  // setValue("sameAsCurrent", checked);  // only for validation

                  if (checked) {
                    setValue("permanent_Zipcode", watch("current_Zipcode"));
                    setValue("permanent_Country", watch("current_Country"));
                    setValue("permanent_State", watch("current_State"));
                    setValue("permanent_City", watch("current_City"));
                    setValue("permanent_Address", watch("current_Address"));
                  }
                }}
              >
                Same as Current
              </Checkbox>
            </Flex>
            <Input maxLength={6} {...register("permanent_Zipcode")} onBlur={handlePermanentPincodeBlur} isDisabled={sameAsCurrent} />
            <FormErrorMessage>
              {errors.permanent_Zipcode?.message}
            </FormErrorMessage>
          </FormControl>

          <FormControl mb={4} isInvalid={!!errors.permanent_Country} isRequired>
            <FormLabel>Permanent Country</FormLabel>
            <Input {...register("permanent_Country")} isDisabled={sameAsCurrent} />
            <FormErrorMessage>
              {errors.permanent_Country?.message}
            </FormErrorMessage>
          </FormControl>

          <FormControl mb={4} isInvalid={!!errors.permanent_State} isRequired>
            <FormLabel>Permanent State</FormLabel>
            <Input {...register("permanent_State")} isDisabled={sameAsCurrent} />
            <FormErrorMessage>
              {errors.permanent_State?.message}
            </FormErrorMessage>
          </FormControl>

          <FormControl mb={4} isInvalid={!!errors.permanent_City} isRequired>
            <FormLabel>Permanent City</FormLabel>
            <Input {...register("permanent_City")} isDisabled={sameAsCurrent} />
            <FormErrorMessage>
              {errors.permanent_City?.message}
            </FormErrorMessage>
          </FormControl>

          <FormControl mb={4} isInvalid={!!errors.permanent_Address} isRequired>
            <FormLabel>Permanent Address</FormLabel>
            <Input {...register("permanent_Address")} isDisabled={sameAsCurrent} />
            <FormErrorMessage>
              {errors.permanent_Address?.message}
            </FormErrorMessage>
          </FormControl>

          <FormControl mb={4} isInvalid={!!errors.blood_Group_Id} isRequired>
            <FormLabel>Blood Group</FormLabel>
            <Select placeholder="Select Blood group" {...register("blood_Group_Id")}>
              {bloodDropdown.map((option: any) => (
                <option key={option.id} value={option.id}>
                  {option.bloodGroup}
                </option>
              ))}
            </Select>
            <FormErrorMessage>{errors.blood_Group_Id?.message}</FormErrorMessage>
          </FormControl>

          <FormControl mb={4} isInvalid={!!errors.emergency_Contact_Name} isRequired>
            <FormLabel>Emergency Contact Name</FormLabel>
            <Input
              type="text"
              placeholder="Enter full name"
              {...register("emergency_Contact_Name")}
              onInput={(e: any) => {
                const val = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                e.target.value = val;
              }}
            />
            <FormErrorMessage>{errors.emergency_Contact_Name?.message}</FormErrorMessage>
          </FormControl>

          <FormControl mb={4} isInvalid={!!errors.emergency_Contact_Number} isRequired>
            <FormLabel>Emergency Contact Number</FormLabel>
            <Input type="tel" placeholder="Enter emergency contact number"  {...register("emergency_Contact_Number")} maxLength={16} onInput={(e: any) => {
              let val = e.target.value.replace(/\D/g, "");
              if (val.startsWith("91")) {
                val = val.slice(2);
              }
              if (val.length > 5) {
                val = `${val.slice(0, 5)} ${val.slice(5, 10)}`;
              }
              e.target.value = `+91 ${val}`;
            }}
            />
            <FormErrorMessage>{errors.emergency_Contact_Number?.message}</FormErrorMessage>
          </FormControl>

          <MultiSelectMenu label="Select Role" placeholder="Select role" options={roleOptions} selectedValues={selectedRoles} setSelectedValues={setSelectedRoles} labelKey="role" valueKey="id" colorScheme="blue" />


          <FormControl mb={4}>
            <FormLabel>Upload Profile (Optional)</FormLabel>
            <Flex align="center" mb={4}>
              <InputGroup>
                <InputLeftElement width="auto" px={2}>
                  <Button as="label" htmlFor="profile-upload" size="sm" colorScheme="gray" leftIcon={<Image src={UploadLogo} />} cursor="pointer" borderRadius="md" w="100%" className="font-poppins text_sm text_regular">
                    Upload
                  </Button>
                  <input id="profile-upload" type="file" accept="image/*" hidden onChange={handleFileChange} ref={fileInputRef} />
                </InputLeftElement>
                <Input className="font-poppins text_sm text_regular" placeholder="No file chosen" value={profile?.name || ""} isReadOnly pl="120px" />
              </InputGroup>
            </Flex>
          </FormControl>

        </Grid>

        <Box mt={6} display="flex" justifyContent="flex-end">
          <Button type="submit" isLoading={loading} colorScheme="green" rightIcon={<ArrowForwardIcon boxSize={4} />}>
            Save & Next
          </Button>
        </Box>
      </Box>
    </MyDiv >

  );
};

export default BasicDetails;
